/* Footer > Accordeon on Mobile
=============================================================== */

// Sélectionner la largeur de la fenêtre
var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

// Menu Responsive Accordéon
document.querySelectorAll('.footer-main .accordeon .title').forEach(function (title) {
  title.addEventListener('click', function (e) {
    if (windowWidth < 768) {
      this.parentElement.classList.toggle('open');
    }
  });
});

// Supprimer Accordéon sur > 768
function removeFooterAccordeon() {
  windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  if (windowWidth >= 768) {
    document.querySelectorAll('.footer-main .accordeon').forEach(function (accordeon) {
      accordeon.classList.remove('open');
    });
  }
}

// Activation sur 'load' et 'resize'
window.addEventListener('load', removeFooterAccordeon);
window.addEventListener('resize', removeFooterAccordeon);

/* Tooltips
=============================================================== */

var tooltipBox = 'off'; // Init
var asideToolTipBox = document.getElementById('tooltip-box'); // Element #tooltip-box

// Tips
var elements = document.querySelectorAll('.tip-link');
elements.forEach(function (element) {
  element.addEventListener('click', function (e) {
    e.preventDefault(); // annule l'action du lien
    // On récupère les données de data-tip
    var dataEvent = this.getAttribute('data-tip');
    // On sélectionne le DOM correspondant
    var tipContent = document.querySelector('.tip-content.' + dataEvent).innerHTML;
    openToolTip(tipContent);
  });
});

// Récupération du HTML .tooltip-content sur le lien
var tooltipLinks = document.querySelectorAll('.tooltip .tooltip-link');
tooltipLinks.forEach(function (link) {
  link.addEventListener('click', function (e) {
    e.preventDefault(); // annule l'action du lien
    var toolTip = this.closest('.tooltip').querySelector('.tooltip-content');
    var toolTipHTMLContent = toolTip.innerHTML;
    openToolTip(toolTipHTMLContent);
  });
});

// Functions Open et Close tooltip
function openToolTip(toolTipHTMLContent) {
  document.getElementById('tooltip-box-content').innerHTML = toolTipHTMLContent; // Injecter le HTML
  tooltipBox = 'on';
  document.body.classList.add('no-scroll');
  document.querySelector('.tooltip-box').classList.add('visible');
  document.querySelector('.site-overlay').classList.add('visible');
  asideToolTipBox.scrollTop = 0; // On scroll le tooltip box
}

function closeToolTip() {
  tooltipBox = 'off';
  document.body.classList.remove('no-scroll');
  document.querySelector('.tooltip-box').classList.remove('visible');
  document.querySelector('.site-overlay').classList.remove('visible');
}

// Close sur icon close tooltip
var closeButtons = document.querySelectorAll('.bt-close-tooltip');
closeButtons.forEach(function (button) {
  button.addEventListener('click', function (e) {
    e.preventDefault(); // annule l'action du lien
    closeToolTip();
  });
});

// Close sur touch en dehors de tooltip
document.addEventListener('mouseup', function (e) {
  if (tooltipBox === 'on') {
    var container = document.querySelector('.tooltip-box');
    if (!container.contains(e.target)) {
      closeToolTip();
    }
  }
});

/* MOBILE MENU
=============================================================== */

// Variables
var mobileNav = 'off'; // Init
var asideMobileNav = document.getElementById('nav-main-wrapper'); // Element #mobile-nav

// Functions Open et Close mobile-nav
function openMobileNav() {
  mobileNav = 'on';
  document.body.classList.add('no-scroll');
  document.querySelector('.mobile-nav').classList.add('visible');
  document.querySelector('.mobile-nav-overlay').classList.add('visible');
  asideMobileNav.scrollTop = 0; // On scroll le mobile-menu
}

function closeMobileNav() {
  mobileNav = 'off';
  document.body.classList.remove('no-scroll');
  document.querySelector('.mobile-nav').classList.remove('visible');
  document.querySelector('.mobile-nav-overlay').classList.remove('visible');
}

// Open sur icon menu header
const iconMenuHeaders = document.querySelectorAll('.header-icon.menu .header-icon-link');
// Parcourir chaque élément et faire quelque chose
iconMenuHeaders.forEach(function (iconMenuHeader) {
  iconMenuHeader.addEventListener('click', function (e) {
    initNav();
    openMobileNav();
  });
});

// Close sur icon close mobile nav
document.querySelector('.bt-close-menu').addEventListener('click', function (e) {
  closeMobileNav();
});

// Close sur touch en dehors de mobile nav
document.addEventListener('mouseup', function (e) {
  if (mobileNav == 'on') {
    var container = document.querySelector('.mobile-nav');
    if (!container.contains(e.target)) {
      closeMobileNav();
    }
  }
});

// On scroll mobile Nav - Sticky nav-top
asideMobileNav.addEventListener('scroll', function (event) {
  var st = asideMobileNav.scrollTop;
  if (st > 0) {
    // Scroll-Up
    document.querySelector('.mobile-nav .nav-top').classList.add('sticky');
  } else {
    // Scroll-Down
    document.querySelector('.mobile-nav .nav-top').classList.remove('sticky');
  }
});

// Fermer Mobile-nav on resize X-Axis (évite transition à 1300px)
window.addEventListener('resize', closeNavOnResize);

function closeNavOnResize() {
  if (mobileNav == 'on' && window.innerWidth >= 1300) {
    document.querySelector('.mobile-nav').style.display = 'none';
    closeMobileNav();
  }
}

/* Mobile-Nav > Navigation interne
=============================================================== */

// Functions go to initNav(level1) ou level2
function initNav() {
  document.querySelector('.mobile-nav').classList.remove('level2_open');
  document.querySelectorAll('.mobile-nav .nav-level_1').forEach(function (el) {
    el.classList.remove('nav-hidden');
  });
  document.querySelectorAll('.mobile-nav .nav-level_2').forEach(function (el) {
    el.classList.add('nav-hidden');
  });
  asideMobileNav.scrollTop = 0; // On scroll le mobile-menu
}

function goToNav_level_2(index) {
  document.querySelector('.mobile-nav').classList.add('level2_open');
  document.querySelectorAll('.mobile-nav .nav-level_1').forEach(function (el) {
    el.classList.add('nav-hidden');
  });
  var level2Items = document.querySelectorAll('.mobile-nav .nav-level_2');
  level2Items.forEach(function (el) {
    el.classList.add('nav-hidden');
  });
  var level2ItemsA = document.querySelectorAll('.mobile-nav .nav-level_2[data-index="' + index + '"]');
  level2ItemsA.forEach(function (el) {
    el.classList.remove('nav-hidden');
  });

  /*level2Items[0].siblings.forEach(function (sibling) {
    sibling.classList.add('nav-hidden');
  });*/

  asideMobileNav.scrollTop = 0; // On scroll le mobile-menu
}

// Liens mobile-nav level1 vers level2
document.querySelectorAll('.mobile-nav .nav-level_1 a.level_2').forEach(function (link) {
  link.addEventListener('click', function (e) {
    e.preventDefault(); // annule l'action du lien
    var index = this.dataset.index;
    goToNav_level_2(index);
  });
});

// Liens mobile-nav level2 vers level1 (Init)
document.querySelectorAll('.mobile-nav .bt-back-menu').forEach(function (link) {
  link.addEventListener('click', function (e) {
    initNav();
  });
});

/* Mobile-Nav > Navigation Mobile Header
=============================================================== */

// Liens header level1 vers level2 (version mobile < 1300px)
document.querySelectorAll('.header-nav-shop-link a.level_2').forEach(function (link) {
  link.addEventListener('click', function (e) {
    if (window.innerWidth < 1300) {
      // Version Mobile
      e.preventDefault(); // annule l'action du lien
      var index = this.dataset.index;
      goToNav_level_2(index);
      openMobileNav();
    }
  });
});

/* Mobile-Nav > Navigation Desktop Header
=============================================================== */

// Functions Open et Close mobile-nav version desktop
function openDesktopNav() {
  desktopNav = 'on';
  document.querySelector('.mobile-nav').classList.add('visible');
}

function closeDesktopNav() {
  desktopNav = 'off';
  document.querySelector('.mobile-nav').classList.remove('visible');
  document.querySelector('.header-nav-shop-link').classList.remove('active');
}

// Liens header level1 vers level2 (version desktop >= 1300px)
document.querySelectorAll('.header-nav-shop-link a.level_2').forEach(function (link) {
  link.addEventListener('mouseenter', function () {
    if (window.innerWidth >= 1300) {
      document.querySelector('.mobile-nav').style.display = 'block';
      this.parentNode.classList.add('active');
      /*this.parentNode.siblings.forEach(function (sibling) {
        sibling.classList.remove('active');
      });*/
      var index = this.dataset.index;
      goToNav_level_2(index);
      openDesktopNav();
    }
    link.addEventListener('mouseleave', function () {
      this.parentNode.classList.remove('active');
    });
  });

  link.addEventListener('mouseleave', function () {
    // Fermer mobile nav on mouseleave (version desktop >= 1300px)
    document.querySelector('.mobile-nav').addEventListener('mouseleave', function () {
      if (window.innerWidth >= 1300) {
        closeDesktopNav();
      }
    });

    document
      .querySelectorAll(
        '.header-nav-ressources, .header-logo, .header-search, .header-icons, .top-bar, .header-nav-shop-links.marques'
      )
      .forEach(function (element) {
        element.addEventListener('mouseenter', function () {
          if (window.innerWidth >= 1300) {
            closeDesktopNav();
          }
        });
      });
  });
});
/*goToNav_level_2(1);
openDesktopNav();*/

/* product > Accordeons
	=============================================================== */

var sectionInfoProduct = document.querySelector('.single-product-info.accordeon');
if (sectionInfoProduct) {
  var titles = document.querySelectorAll('.single-product-info.accordeon .title');

  titles.forEach(function (title) {
    title.addEventListener('click', function (e) {
      this.parentElement.classList.toggle('open');
    });
  });
}

/* swiper related products
 	/* Related Products > Swiper Initialize
	=============================================================== */

/* Image Gallery > Fancybox Initialize
	=============================================================== */

/* Image Gallery > Swiper Initialize
	=============================================================== */

/* Image Gallery Thumbnails > Swiper Initialize
	=============================================================== */

// check element
var swiperThumbnailsDOM = document.querySelector('.swiper-thumbnails');

// if exists
if (swiperThumbnailsDOM) {
  var swiperThumbnails = new Swiper('.swiper-thumbnails', {
    spaceBetween: 8,
    slidesPerView: 5.8,
    slidesOffsetBefore: 8,
    slidesOffsetAfter: 8,
    freeMode: true,
    lazy: true, // Enable lazy loading
    watchSlidesProgress: true,
    breakpoints: {
      768: {
        slidesPerView: 8.5,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
      1200: {
        slidesPerView: 9.5,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
    },
  });
}

var swiperGallery = new Swiper('.product-image-swiper-gallery', {
  autoHeight: true,
  lazy: true, // Enable lazy loading
  spaceBetween: 0,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  thumbs: {
    swiper: swiperThumbnails,
  },
  on: {
    slideChange: function () {
      console.log('swiper initialized');
    },
  },
});

// Image Gallery

const fancybox_dom = document.querySelector('.swiper-gallery [data-fancybox="gallery"]');
if (fancybox_dom) {
  Fancybox.bind('.swiper-gallery [data-fancybox="gallery"]', {
    Images: {
      protected: true,
    },
  });
}

// Image Gallery2

const fancybox_dom2 = document.querySelector('.product-with-variant [data-fancybox="gallery"]');
if (fancybox_dom2) {
  Fancybox.bind('.product-with-variant [data-fancybox="gallery"]', {
    Images: {
      protected: true,
    },
  });
}

// Page Marques
var swiper = new Swiper('.marque-pop-list', {
  slidesPerView: 2.2,
  spaceBetween: 15,
  lazy: true,
  grid: {
    rows: 2,
  },
  breakpoints: {
    768: {
      slidesPerView: 3.2,
      spaceBetween: 20,
      grid: { rows: 2 },
    },
    992: {
      slidesPerView: 4.5,
      spaceBetween: 20,
      grid: { rows: 2 },
    },
    1200: {
      slidesPerView: 6,
      spaceBetween: 25,
      grid: { rows: 2 },
    },
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    /*hide: true,*/
  },
});

// Accordeons
// Page Accordion
function show_accordion() {
  // Sélectionner tous les titres des accordeons
  const accordionTitles = document.querySelectorAll('.accordion-item .accordion-title');

  accordionTitles.forEach(function (title) {
    title.addEventListener('click', function () {
      // Fermer tous les autres accordeons
      const parent = this.parentElement;
      const siblings = parent.parentElement.querySelectorAll('.accordion-item');

      siblings.forEach(function (sibling) {
        if (sibling !== parent) {
          sibling.classList.remove('open');
        }
      });

      // Ouvrir/fermer l'accordéon actuel
      parent.classList.toggle('open');
    });
  });
}

// Rafraichir à l'update du panier
document.body.addEventListener('updated_cart_totals', function () {
  show_accordion();
});

// Init
show_accordion();

/* BLOG ARTICLE > Fancybox sur images -------------------------------------------------------------------- */

/*document.querySelectorAll('.template-article .post-content img').forEach(function (img) {
  const link = document.createElement('a');
  // Définit l'attribut href du lien avec la source de l'image
  link.href = img.src;
  // Place l'image dans l'élément <a>
  img.parentNode.insertBefore(link, img);
  link.appendChild(img);
  link.setAttribute('data-fancybox', 'gallery');

  //image.setAttribute('data-fancybox', 'gallery'); // Remplace 'data-custom' et 'value' par ce que tu souhaites
});*/

/* BLOG ARTICLE > Fancybox sur a > img -------------------------------------------------------------------- */

document.querySelectorAll('.template-article .post-content a').forEach(function (anchor) {
  if (anchor.querySelector('img')) {
    anchor.setAttribute('data-fancybox', 'gallery');
  }
});

// Init Fancybox
const fancybox_blog = document.querySelector('.template-article .post-content [data-fancybox="gallery"]');
if (fancybox_blog) {
  Fancybox.bind('.template-article .post-content [data-fancybox="gallery"]', {
    Images: {
      protected: true,
    },
  });
}

/* BLOG TUTORIELS > Fancybox sur img ----------------------------------- */
document.querySelectorAll('.template-article .post-tutoriels img').forEach(function (img) {
  const link = document.createElement('a');
  // Définit l'attribut href du lien avec la source de l'image
  link.href = img.src;
  // Place l'image dans l'élément <a>
  img.parentNode.insertBefore(link, img);
  link.appendChild(img);
  link.setAttribute('data-fancybox', 'gallery');

  //image.setAttribute('data-fancybox', 'gallery'); // Remplace 'data-custom' et 'value' par ce que tu souhaites
});

// Init Fancybox
const fancybox_tutos = document.querySelector('.template-article .post-tutoriels [data-fancybox="gallery"]');
if (fancybox_tutos) {
  Fancybox.bind('.template-article .post-tutoriels [data-fancybox="gallery"]', {
    Images: {
      protected: true,
    },
  });
}
